import React from 'react';

const CustomEventLeaderboardPlayersColumn = ({ playersList }) => {
    if (playersList === null || playersList === undefined) return null;

    return playersList.players.map((player) => {
        return (
            <div className={'custom-event-leaderboard__row'} key={player.lastName}>
                {
                    player !== undefined && player !== null &&
                    <div className={'custom-event-leaderboard__cell-player-fullname'}>
                        <div className={'custom-event-leaderboard__cell-player-lastname'}>{player.lastName}</div>
                        <span className={'custom-event-leaderboard__cell-player-separator'}>,</span>
                        <div className={'custom-event-leaderboard__cell-player-firstname'}>{player.firstName}</div>
                    </div>
                }
            </div>
        );
    });
};

export default CustomEventLeaderboardPlayersColumn;
